import React, { ReactNode } from 'react';
import {
  Tooltip as MuiTooltip,
  createTheme,
  ThemeProvider,
  Theme,
  TooltipProps,
} from '@mui/material';
import { colors } from 'src/sass/common/_variables';

export type ITooltipPlacement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

type Props = TooltipProps & {
  title: string | ReactNode;
  istheme?: Theme;
  arrow?: boolean;
  placement: ITooltipPlacement;
  children: React.ReactElement<any, any>;
  hide?: boolean;
};

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: colors.$colorWhite,
          color: colors.$colorBlack,
          fontFamily: 'Inter, system-ui, Roboto',
          fontWeight: 400,
          fontSize: '14px',
          boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.12)',
          border: `1px solid ${colors.$colorDarkPrimary150}`,
          borderRadius: '4px',
          maxHeight: '200px',
          overflowY: 'auto',
        },
      },
    },
  },
});

export default function Tooltip({
  title,
  placement,
  children,
  istheme,
  arrow,
  hide,
  ...props
}: Props) {
  if (hide) return children;
  return (
    <ThemeProvider theme={!istheme ? theme : istheme}>
      <MuiTooltip {...props} arrow={arrow} title={title} placement={placement}>
        {children}
      </MuiTooltip>
    </ThemeProvider>
  );
}
